import { removeTags } from 'utils/html';
import { REFERENCE_CITATION_MARKER } from '../nodes/ReferenceCitationNodeWithExportDom';

export const excludeHtmlTag = (text = ''): string => {
  return removeTags(text)
    .replaceAll(REFERENCE_CITATION_MARKER, '')
    .replace(/[\n\t]/g, '');
};
